module.exports = __webpack_public_path__ + "img/icon.119fa440.svg";